import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/hooks/useAuth";
import { Users } from "lucide-react";
import { userApi } from "@/lib/api/admin-api";
import { useLingui } from "@lingui/react/macro";
import { StatCard } from "@/components/common/StatCard";

/**
 * Total / active / inactive user counts. With `adminScope`, counts span every
 * organization (super-admin internal view); otherwise they are org-scoped.
 */
export function UserStats({ adminScope = false }: { adminScope?: boolean }) {
  const { t } = useLingui();
  const { isAuthenticated } = useAuth();

  const { data: stats, isLoading } = useQuery({
    queryKey: ["users", "stats", adminScope ? "all-orgs" : "org"],
    queryFn: () => userApi.getGlobalStats({ adminScope }),
    enabled: isAuthenticated,
  });

  return (
    <div className="grid grid-cols-3 gap-3 p-3 bg-(--color-surface-muted) rounded-lg">
      <StatCard label={t`Total Users`} value={stats?.total ?? 0} icon={Users} loading={isLoading} />
      <StatCard label={t`Active`} value={stats?.active ?? 0} icon={Users} loading={isLoading} />
      <StatCard label={t`Inactive`} value={stats?.inactive ?? 0} icon={Users} loading={isLoading} />
    </div>
  );
}
